import IUserSkill from "@skills-app/models/userSkills";
import {
  createReducer,
  on,
  createFeatureSelector,
  createSelector,
} from "@ngrx/store";
import { ISkillChampion } from "@skills-app/models/skill-champion";
import { SkillChampionApiActions, SkillChampionPageActions } from "../actions";

export interface ISkillChampionsState {
  selectedSkillChampions: ISkillChampion[];
  selectedConsultants: IUserSkill[];
}

const initialState: ISkillChampionsState = {
  selectedSkillChampions: [],
  selectedConsultants: [],
};

export const reducer = createReducer(
  initialState,

  on(
    SkillChampionApiActions.requestCurrentSkillChampionsSuccess,
    (state, action) => ({
      ...state,
      selectedSkillChampions: action.skillChampions ?? [],
    }),
  ),

  on(SkillChampionApiActions.upsertSkillChampionsSuccess, (state, action) => ({
    ...state,
    selectedSkillChampions: action.skillChampions ?? [],
  })),

  on(SkillChampionPageActions.clearSkillChampions, (state) => ({
    ...state,
    selectedSkillChampions: [],
  })),

  on(SkillChampionPageActions.selectConsultants, (state, action) => ({
    ...state,
    selectedConsultants: action.consultants,
  })),

  on(SkillChampionPageActions.addToSelectedConsultants, (state, action) => ({
    ...state,
    selectedConsultants:
      state.selectedConsultants.length >= 10 ||
      state.selectedConsultants.includes(action.consultant)
        ? state.selectedConsultants
        : [...state.selectedConsultants, action.consultant],
  })),

  on(
    SkillChampionPageActions.removeFromSelectedConsultants,
    (state, action) => ({
      ...state,
      selectedConsultants: !state.selectedConsultants.includes(action.consultant)
        ? state.selectedConsultants
        : state.selectedConsultants.filter(
            (c) => c.AzureId !== action.consultant.AzureId,
          ),
    }),
  ),

  on(SkillChampionPageActions.clearSelectedConsultants, (state) => ({
    ...state,
    selectedConsultants: [],
  })),
);

export const getSkillChampionsState =
  createFeatureSelector<ISkillChampionsState>("skillChampions");

export const getSelectedSkillChampions = createSelector(
  getSkillChampionsState,
  (state) => state.selectedSkillChampions,
);

export const getSelectedConsultants = createSelector(
  getSkillChampionsState,
  (state) => state.selectedConsultants,
);
